import { useMutation } from '@tanstack/react-query';
import { toast } from '../../../lib/toast';
import { exportLeadsPdf } from '../api/leads';
import type { ExportLeadsParams } from '../types';

function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function useExportLeadsPdf() {
  return useMutation({
    mutationFn: (params: ExportLeadsParams) => exportLeadsPdf(params),
    onSuccess: (blob) => {
      const date = new Date().toISOString().slice(0, 10);
      downloadBlob(blob, `leads-report-${date}.pdf`);
      toast.success('Leads exported as PDF successfully');
    },
    onError: (err: unknown) => {
      const axiosErr = err as { response?: { data?: { detail?: string; title?: string } } };
      const detail = axiosErr.response?.data?.detail ?? axiosErr.response?.data?.title;
      toast.error(detail ?? 'Failed to export leads as PDF');
    },
  });
}
